
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import RemoteServices from "@/services/RemoteServices";
import WorkingHours from "@/domain/restaurant/WorkingHours";
import TimeService from "@/services/TimeService";
import UtilService from "@/services/UtilService";
@Component
export default class BookingAvailableTimes extends Vue {
  @Prop({ default: false })
  value!: boolean;

  @Prop({ default: null })
  date!: Date | null;

  @Prop({ default: null })
  workingHours!: WorkingHours | null;

  @Prop({ default: 0 })
  numberOfPeople!: number;

  @Prop({ default: null })
  preferredRoom!: number | null;

  @Prop({ default: null })
  bookingId!: number | null;

  @Prop({ default: "" })
  selectedTime!: string;

  loading = false;

  times: String[] = [];

  disabled = true;

  timeout = false;

  get timesWithManualTime() {
    const array = [...this.times];
    for (let i = 0; i < this.times.length; i++) {
      if (this.selectedTime === this.times[i]) return array;
    }
    if (this.selectedTime != null && this.selectedTime !== "")
      array.push(this.selectedTime);
    array.sort(UtilService.stringComparatorAscending);
    return array;
  }

  public get canGetAvailableTimes() {
    return (
      this.workingHours != null &&
      this.numberOfPeople > 0 &&
      this.date != null &&
      this.preferredRoom != null &&
      !this.timeout
    );
  }

  resetTimeOut() {
    this.timeout = false;
    this.$emit("input", this.canGetAvailableTimes);
  }

  setTimeOut() {
    this.timeout = true;
    this.$emit("input", this.canGetAvailableTimes);
    setTimeout(this.resetTimeOut, 2000);
  }

  get selectTime() {
    return this.selectedTime;
  }

  set selectTime(newTime: string) {
    this.$emit("update-time", newTime);
  }

  getTimeFromIsoString(isoString: string) {
    return TimeService.getTimeFromISOString(isoString);
  }

  get changes() {
    return (
      this.workingHours?.workingHoursId.toString() +
      this.numberOfPeople.toString() +
      this.date?.toString() +
      this.preferredRoom?.toString()
    );
  }

  @Watch("changes")
  clearTimes() {
    if (!this.disabled) {
      this.disabled = true;
      this.times = [];
      this.selectTime = "";
    }
    this.$emit("input", this.canGetAvailableTimes);
  }

  public async getAvailableTimes() {
    this.loading = true;
    if (this.canGetAvailableTimes) {
      this.$emit("update-time", "");
      this.times = [];
      try {
        this.times = await RemoteServices.getAvailableTimesByWorkingHours(
          TimeService.getISODateString(this.date!),
          this.numberOfPeople!,
          this.workingHours!,
          this.preferredRoom!,
          this.bookingId!
        );
      } catch (error) {
        await this.$store.dispatch("error", error.message);
      }
      this.times.sort(UtilService.stringComparatorAscending);
      this.disabled = false;
      this.setTimeOut();
    } else console.log("INVALID PARAMETERS GET AVAILABLE TIMES");
    this.loading = false;
  }
}
